import React from 'react';
import {Pressable, StyleSheet} from 'react-native';

export default function PressableWithOpacityFeedback(props) {
  let propsStyle = props.style;

  if (Array.isArray(props.style)) {
    propsStyle = StyleSheet.flatten(props.style);
  }

  return (
    <Pressable
      {...props}
      style={({pressed}) => [{opacity: pressed ? 0.5 : 1.0}, propsStyle]}>
      {!!props.children && props.children}
    </Pressable>
  );
}
